import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=2825958c&"
import script from "./ErrorPage.vue?vue&type=script&lang=ts&"
export * from "./ErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=2825958c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports